export enum BuiltInDictionaryType {
  AC_SUPERIOR_ACCEPTING_REQUEST = 0,
}
